// P1-018: Overload value visualization gauge
import { useHardwareStore } from '../stores/hardwareStore';
import { OverloadCalculator } from '../systems/OverloadCalculator';
import type { OverloadLevel } from '../systems/OverloadCalculator';

/** Description of battle impact per overload level */
const OVERLOAD_DESCRIPTIONS: Record<OverloadLevel, string> = {
  none:   '系统正常运行，无负面效果。',
  light:  '轻度过载：战斗中每回合5%概率触发算力波动。',
  medium: '中度过载：每回合15%概率算力波动，Agent攻击-10%。',
  heavy:  '重度过载：每回合30%概率算力波动，攻击-20%，防御-15%。',
};

export function OverloadMeter() {
  const powerUsage = useHardwareStore((s) => s.getTotalPower());
  const powerLimit = useHardwareStore((s) => s.getTotalPowerLimit());
  const heatGen = useHardwareStore((s) => s.getTotalHeatGen());
  const cooling = useHardwareStore((s) => s.getTotalCooling());

  const overloadResult = OverloadCalculator.evaluate(powerUsage, powerLimit, heatGen, cooling);
  const { overloadValue, overloadLevel } = overloadResult;

  // Gauge goes from 0 to ~20 (heavy is >10), cap display at 20
  const maxDisplay = 20;
  const fillPercent = Math.min(100, (overloadValue / maxDisplay) * 100);

  const levelLabel: Record<OverloadLevel, string> = {
    none:   'NORMAL',
    light:  'LIGHT',
    medium: 'MEDIUM',
    heavy:  'HEAVY',
  };

  return (
    <div className="overload-meter">
      <div className="overload-meter__header">
        <span className="overload-meter__title">过载指数: {overloadValue}</span>
        <span className={`overload-meter__level overload-meter__level--${overloadLevel}`}>
          {levelLabel[overloadLevel]}
        </span>
      </div>

      <div className="overload-meter__bar">
        <div
          className={`overload-meter__fill overload-meter__fill--${overloadLevel}`}
          style={{ width: `${fillPercent}%` }}
        />
      </div>

      <div className="overload-meter__desc">
        {OVERLOAD_DESCRIPTIONS[overloadLevel]}
      </div>
    </div>
  );
}
